<div class="skeleton-header-animation my-2"></div>
<div class="skeleton-card clip4"></div>

<div class="skeleton-header-animation my-2 mt-4"></div>

<div class="skeleton-columns">
    <div class="skeleton-item clip6 position-relative skeleton rounded-1 clip6-corner"></div>
    <div class="skeleton-item clip6 position-relative skeleton rounded-1 clip6-corner"></div>
    <div class="skeleton-item clip6 position-relative skeleton rounded-1 clip6-corner"></div>
</div>
